import { Formik } from "formik";
import * as Yup from "yup";
import {
  Form,
  Select,
  Input,
  Radio,
  Button,
  Row,
  Col,
  Tooltip,
  Popover,
  Space,
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import { CheckSquare, Edit3, Trash2 } from "lucide-react";

const { TextArea } = Input;

const validationSchema = Yup.object().shape({
  checklist_label: Yup.string().nullable().required("Label is required"),
  // mode: Yup.string().nullable().required("Choose Auto/Manual"),
  // device_id: Yup.string()
  //   .nullable()
  //   .when("mode", {
  //     is: "auto",
  //     then: (schema) => schema.required("Device is required in Auto mode"),
  //   }),
});

export default function Checklist({
  editIndex,
  onSubmit = (values) => console.log("Submitted values:", values),
  device_list,
  values = {
    checklist_label: null,
    // mode: null,
    // device_id: null,
  },
}) {
  return (
    <Formik
      initialValues={values}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ values, errors, touched, setFieldValue, handleSubmit }) => (
        <Form layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Checklist"
                validateStatus={
                  touched.checklist_label && errors.checklist_label
                    ? "error"
                    : ""
                }
                help={touched.checklist_label && errors.checklist_label}
              >
                <TextArea
                  rows={2}
                  placeholder="Label for the checklist"
                  value={values.checklist_label}
                  onChange={(e) =>
                    setFieldValue("checklist_label", e.target.value)
                  }
                />
              </Form.Item>
            </Col>

            {/* <Col span={4}>
              <Form.Item
                label="Mode"
                validateStatus={touched.mode && errors.mode ? "error" : ""}
                help={touched.mode && errors.mode}
                tooltip="Choose either 'Auto' or 'Manual' as the operation type"
              >
                <Radio.Group
                  value={values.mode}
                  onChange={(e) => setFieldValue("mode", e.target.value)}
                >
                  <Radio value="auto">Auto</Radio>
                  <Radio value="manual">Manual</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            {values.mode === "auto" && (
              <Col span={8}>
                <Form.Item
                  label="Select Device"
                  validateStatus={
                    touched.device_id && errors.device_id ? "error" : ""
                  }
                  help={touched.device_id && errors.device_id}
                >
                  <Space.Compact className="w-full">
                    <Select
                      allowClear
                      showSearch
                      value={values.device_id}
                      placeholder="Select Device"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={(val) =>
                        setFieldValue("device_id", val || null)
                      }
                      options={device_list?.map((d) => ({
                        value: d.device_id,
                        label: d.device_name,
                      }))}
                    />
                    <Tooltip title="Add Device">
                      <Button
                        icon={<PlusOutlined />}
                        onClick={() => {
                          // setModalVisible(true);
                        }}
                      />
                    </Tooltip>
                  </Space.Compact>
                </Form.Item>
              </Col>
            )} */}

            {/* Submit */}
            <Col span={24}>
              <Button type="primary" htmlType="submit" block>
                {editIndex !== null ? "Update" : "Add"}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
}

export const ChecklistCard = ({ item, onEdit, onDelete, fromView }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition p-3 text-sm">
      {/* Header */}
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          <div className="p-1.5 bg-indigo-100 rounded-md">
            <CheckSquare className="w-4 h-4 text-indigo-600" />
          </div>
          <p
            className="text-gray-900 leading-tight text-base break-all"
            title={item.checklist_label}
          >
            {item.checklist_label}
          </p>
        </div>

       {!fromView && <div className="flex items-center gap-1">
          {onEdit && (
            <button
              type="button"
              className="p-1.5 rounded-md hover:bg-blue-50 transition-colors border border-transparent hover:border-blue-200"
              onClick={() => onEdit()}
              title="Edit checklist"
            >
              <Edit3 className="w-4 h-4 text-blue-600" />
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              className="p-1.5 rounded-md hover:bg-red-50 transition-colors border border-transparent hover:border-red-200"
              onClick={() => onDelete()}
              title="Delete checklist"
            >
              <Trash2 className="w-4 h-4 text-red-500" />
            </button>
          )}
        </div>}
      </div>
    </div>
  );
};
